<template>
  <div>
    <v-row>
      <v-col cols="12">
        <gg-card-title class="pt-0">
          My Invoices
        </gg-card-title>
      </v-col>
      <v-col cols="12" class="py-0">
        <profile-navigation />
      </v-col>
      <v-col cols="12">
        <gg-loading :loading="!invoices_loaded" type="table">
          <gg-card>
          <gg-card-text>
            <v-data-table
              :headers="headers"
              :items="invoices"
              :footer-props="{ itemsPerPageOptions: this.paginationBilling }"
              sort-by="id"
              sort-desc
            >
              <template v-slot:item.id="{ item }">
                <router-link :to="`/billing/${item.id}`" custom v-slot="{ navigate }">
                  <button
                    @click="navigate"
                    @keypress.enter="navigate"
                    role="link"
                    aria-label="View Invoice"
                    class="ggs-item-title primary--text">
                    #{{ item.id }}
                  </button>
                </router-link>
              </template>
              <template v-slot:item.total="{ item }">
                ${{ item.totall }}
              </template>
              <template v-slot:item.status="{ item }">
                <v-icon small class="pb-1" :color="statusColor(item.status)">mdi-circle</v-icon>
                {{ item.status }}
              </template>
              <template v-slot:item.date="{ item }">
                {{ formatRenewalDate(parseRenewalDate(item.date)) }}
              </template>
              <template v-slot:item.duedate="{ item }">
                {{ formatRenewalDate(parseRenewalDate(item.duedate)) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <gg-btn color="primary" :to="`/billing/${item.id}`">
                  View Invoice
                  <span class="visually-hidden text-lowercase">
                    button
                  </span>
                </gg-btn>
              </template>
            </v-data-table>
          </gg-card-text>
        </gg-card>
        </gg-loading>
      </v-col>
    </v-row>
    <cancellations-list></cancellations-list>
  </div>
</template>

<script>
// import amapi from '@/api/amapi'
import { mapActions, mapGetters } from 'vuex'
import { statusColor, parseRenewalDate, formatRenewalDate } from '@/helpers/helpers'
import ProfileNavigation from 'Components/Profile/ProfileNavigation'
import CancellationsList from '@/components/Cancellations/CancellationsList'

export default {
  name: 'BillingList',
  components: {
    ProfileNavigation,
    CancellationsList,
  },
  data: () => ({
    invoices_loaded: false,
    headers: [
      { text: 'Invoice #', sortable: true, value: 'id' },
      { text: 'Total', sortable: false, value: 'total' },
      { text: 'Status', sortable: true, value: 'status' },
      { text: 'Invoice Date', sortable: true, value: 'date' },
      { text: 'Due Date', sortable: true, value: 'duedate' },
      { text: 'Details', sortable: false, value: 'actions', align: 'center' },
    ],
  }),
  computed: {
    ...mapGetters({
      invoices: 'billing/invoices',
      paginationBilling: 'paginationBilling'
    })
  },
  methods: {
    ...mapActions({
      getInvoices: 'billing/getInvoices',
      reportError: 'reportError'
    }),
    async loadData () {
      try {
        await this.getInvoices()

        this.invoices_loaded = true
      } catch (e) {
        this.invoices_loaded = true
        this.reportError(e)
      }
    },
    statusColor,
    parseRenewalDate,
    formatRenewalDate,
  },
  created () {
    this.loadData()
  }
}
</script>
